import React from "react";

import "./faq.css";
import FAQs from "./features/FAQs";
function App() {
  return (
    <div>
      <FAQs />
    </div>
  );
}

export default App;
